var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-navbar',{attrs:{"type":"light"}},[_c('div',{attrs:{"id":"photo"}},[_c('img',{attrs:{"src":"nts.png","alt":""}})])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }